import { emptyObj } from 'util/objects'

export const selectById = state => {
  return state.tickets.byId || emptyObj
}
